const colorsNo = 4;
const className = 'slx-js-colorSet';
const sessionStorageVariable = 'slxJsColorSet';

function checkCookie() {
	console.log(sessionStorage, sessionStorage.getItem(sessionStorageVariable));
	return sessionStorage.getItem(sessionStorageVariable);
}

function setValue() {
	let currentColorValue = checkCookie();
	if(!currentColorValue) {
		currentColorValue =  Math.floor(Math.random() * colorsNo) + 1;
		sessionStorage.setItem(sessionStorageVariable, currentColorValue);
	}
	const currentClass = className + currentColorValue;
	document.body.classList.add(currentClass);
}


setValue();
